import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WorkspaceName = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.I};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.lineHeights.C};
  text-align: center;
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
  margin-top: 12px;
`
